import { Action, Dispatch, MiddlewareAPI } from 'redux'

import staticData from '../../config/staticData'

import serviceStatusSchema from '../../schemas/server/serviceStatus'

import { setServiceStatus } from '../../actions/service'
import { GET_SERVICE_STATUS } from '../../actions/service/getServiceStatus'
import { morphism } from 'morphism'
import { generateAuthorizationHeaders } from '../../utils/requests'

const getServiceStatus = async () => {
    try {
        const {
            endpoints: {
                allotments: { url, headers },
            }
        } = staticData

        const fixedUrl = url.endsWith('/') ? url : `${url}/`
        const requestUrl = `${fixedUrl}serviceStatus/getStatus`
        const authHeaders = await generateAuthorizationHeaders(headers)

        return await fetch(requestUrl, {
            headers: { ...headers, ...authHeaders }
          })
          .then(r => r.text()
          .then(data => ({ status: r.status, body: data })))
        .catch(function() {
            console.log("Something went wrong while fetching the service status.")
        })
    } catch (error) {
        console.log(error)
    }
}

export default (store: MiddlewareAPI) => (next: Dispatch) => async (
    action: Action
) => {
    next(action)

    if (action.type !== GET_SERVICE_STATUS) return

    const response = await getServiceStatus()

    const serviceStatus = morphism(serviceStatusSchema, response)

    if (serviceStatus) {
        store.dispatch(setServiceStatus(serviceStatus))
    }
}
